import Axios from 'axios';
import Qs from 'qs';

export default {
	//巡检日志列表

	listPage(
		task_name,
		device_type,
		state,
		page,
		limit
	) {
		return Axios.get('/deviceManage/api/admin/patrol-task-log', {
			params: {
				task_name,
				device_type,
				state,
				page,
				limit
			},
			paramsSerializer(params) {
				return Qs.stringify(params);
			}
		});
	},

	list() {
		return Axios.get('/deviceManage/api/admin/patrol-task-log', {})
	}
}